import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import { useOidcSilent } from './silentProvider';

export function ClubSauceConnector() {
	const queryClient = useQueryClient();
	const { isLoading, user } = useAuth();
	const [isSilentLoading] = useOidcSilent();

	const accessToken = user?.access_token;
	const userId = user?.profile?.sub;

	// Invalidate endpoints on user change
	useEffect(() => {
		queryClient.invalidateQueries();
	}, [userId, queryClient]);

	// handle auth changes
	useEffect(() => {
		// Pause sooner
		api.apiPause();

		if (isLoading || isSilentLoading) return undefined;

		if (accessToken) {
			api.apiSetAuthorization(`Bearer ${accessToken}`);
		}

		// debounce to allow for oidc to catchup
		const timer = setTimeout(() => {
			api.apiUnpause();
		}, 1);

		return () => {
			clearTimeout(timer);
		};
	}, [accessToken, isLoading, isSilentLoading]);

	return null;
}

export default ClubSauceConnector;
